export const ACTIONS = {
  SET_COMPANY: 'setCompany',
  SET_COMPANY_CREATE_ERROR: 'setCompanyCreateError',
  SET_COMPANY_SEARCH_INPUT: 'setCompanySearchInput',
  SET_ROLE: 'setRole',
  SET_ROLE_SEARCH_INPUT: 'setRoleSearchInput',
  SET_ACCESS_LEVEL: 'setAccessLevel',
  SET_SAVE: 'setSave',
  SET_SELECTED_OFFERING: 'setSelectedOffering',
  SET_LICENSE_OPERATION: 'setLicenseOperation',
  SET_OFFERINGS: 'setOfferings',
  RESET_SUBSCRIPTION_DATA: 'resetSubscriptionData',
};
